<template>
  <span v-if="hasAddress" :class="[hasMultipleLines && 'gu-datagrid-multi-line']">
    <template v-if="multiLine">
      <span v-if="streetValue">{{ streetValue }}</span>
      <span v-if="cityStateZip" class="gu-datagrid-cell-metadata">{{ cityStateZip }}</span>
    </template>
    <template v-else>
      {{ streetValue }}, {{ cityStateZip }}
    </template>
  </span>
  <span v-else-if="emptyValueText" :class="[emptyValueClass || 'gu-datagrid-empty-value']">
    {{ emptyValueText }}
  </span>
</template>

<script setup>
const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const {
  data,
  //
  streetAddress,
  city,
  state,
  zip,
  multiLine,
  emptyValueText,
  emptyValueClass,
} = props.params

const streetValue = data[streetAddress]
const cityValue = data[city]
const stateValue = data[state]
const zipValue = data[zip]

const hasAddress = streetValue || cityValue || stateValue || zipValue
const cityStateZip = [cityValue, stateValue, zipValue].filter(Boolean).join(', ')
const hasMultipleLines = multiLine && streetAddress && cityStateZip
</script>
